import React from 'react';
import INDT from '../Imagens/logo indt.svg';
export default function Footer() {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        flexDirection: 'column',
        width: '100%',
        height: 120,
        borderTop: 30,
      }}
    >
      <p
        style={{
          textAlign: 'left',
          fontFamily: 'montserrat',
          fontSize: 14,
          width: '100%',
          paddingTop: 60,
        }}
      >
        V0.2.1
      </p>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'flex-start',
          width: '100%',
          height: 20,
        }}
      >
        <p style={{ textAlign: 'left', fontFamily: 'montserrat', fontSize: 12 }}>
          Desenvolvido por &nbsp;
        </p>
        <img src={INDT} />
        <p style={{ textAlign: 'left', fontFamily: 'montserrat', fontSize: 12 }}>
          &nbsp; All Rights Reserved@2022.
        </p>
      </div>
    </div>
  );
}
